import { IMG_META } from "@/data/imgMeta";

export function imgProps(src, sizes, { eager = false } = {}) {
  if (!src || !src.startsWith("/assets/")) return { src, loading: eager ? "eager" : "lazy", decoding: "async" };
  const slug = src.slice("/assets/".length, -".webp".length);
  const m = IMG_META[slug];
  if (!m) return { src, loading: eager ? "eager" : "lazy", decoding: "async" };
  const props = {
    src,
    loading: eager ? "eager" : "lazy",
    decoding: "async",
    width: m.w,
    height: m.h,
    style: { aspectRatio: `${m.w} / ${m.h}` },
  };
  if (eager) props.fetchPriority = "high";
  if (m.v && m.v.length) {
    props.srcSet = m.v.map((w) => `/assets/${slug}-${w}.webp ${w}w`).join(", ") + `, /assets/${slug}.webp ${m.w}w`;
    props.sizes = sizes;
  }
  return props;
}
